import Vue from 'vue'
import VueRouter from 'vue-router'
import Completed from "@/views/Completed";
import Web from "@/views/Web"

Vue.use(VueRouter)

const routes = [
    {
        path: '/:businessId',
        name: 'Web',
        component: Web
    },
    {
        path: '/:businessId/completed',
        name: 'Completed',
        component: Completed,
        props: true
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
